import { SText } from '@setvi/shared/components';
import { Box, IconButton, styled } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { AIButton } from 'componentsV2/ai';

interface HeaderProps {
  title: string;
  loading?: boolean;
  onClose: () => void;
  onResetData?: (forceRefresh: boolean) => void;
  onResetMetadata?: () => void;
}

const Flex = styled(Box)({
  gap: 16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
});

const Header = ({
  title,
  loading,
  onClose,
  onResetMetadata,
  onResetData
}: HeaderProps) => (
  <Flex padding={4}>
    <SText title={title} size="xl" weight="bold" />

    <Flex>
      {!loading && (
        <AIButton
          newDesign
          variant="outlined"
          title="Reset Data"
          items={[
            {
              text: 'Reset Metadata',
              onClick: onResetMetadata,
              flag: true
            },
            {
              text: 'Reset Sales Enablement',
              onClick: () => onResetData(false),
              flag: true
            },
            {
              text: 'Reset All',
              onClick: () => {
                onResetData && onResetData(true);
                onClose();
              },
              flag: true
            }
          ]}
        />
      )}

      <IconButton aria-label="close" size="small" onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Flex>
  </Flex>
);

export default Header;
